{
  "FUEL-PLACES--PLACES":"Locais Cadastrados",
  "FUEL-PLACES--SELECT":"Esses locais podem ser cadastrados pelo login da web. Selecione um endereço",
  "FUEL-PLACES--SEARCH":"Procurar",
  "FUEL-PLACES--NOT-FOUND":"Nenhum endereço encontrado"
}